module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres8ax-popup-detail-deduction",
      "id": "hres8ax-popup-detail-deduction",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES8AXC2']['50']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('u', [_vm._v(_vm._s(_vm.labels['HRES8AXC2']['50']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-70",
    attrs: {
      "id": "amtdeduct",
      "name": "amtdeduct"
    }
  }, [_vm._v(_vm._s(_vm.detailDeductionSelected.amtdeduct))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('u', [_vm._v(_vm._s(_vm.labels['HRES8AXC2']['60']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "detail-header"
  }, [_c('u', [_vm._v(_vm._s(_vm.labels['HRES8AXC2']['70']))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62692a57!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres8ax/popupDetailDeduction.vue
// module id = 3815
// module chunks = 1